<div [id]="'chart_' + id">
  <div [id]="'column-chart_' + id"></div>
</div>
